type SubscriptionConflictError = {
  response?: {
    status?: number
    data?: {
      error_type?: string
      subscription_id?: number | string
      debug_final_check?: boolean
    }
  }
}

export function isAlreadySubscribedConflict(error: unknown): boolean {
  const conflict = (error ?? {}) as SubscriptionConflictError
  return (
    conflict.response?.status === 409 &&
    (conflict.response?.data?.error_type === 'already_subscribed' ||
      Boolean(conflict.response?.data?.subscription_id) ||
      conflict.response?.data?.debug_final_check === true)
  )
}
